<template>
  <div class="container">
    <section id="editContent" class="columnContainer">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.nav_menu}}</h1>
        <MenuList
          :locale="locale"
          :main="setMenu.main"
          :list="menuGroup"
          :init="setInit"
          @checked="onChecked" />
        <Pagination
          :option="pagingOption"
          @onPagingClick="onPagingClick" />
      </div>
      <div class="innerSide"><div class="sideBox">
      </div></div>
      <Templates
        v-if="showTemplates"
        :templates="templates" />
    </section>
    <div id="setContent">
      <SetMenu
        :locale="locale"
        :checked="checkedList"
        :list="menuList"
        :templates="templates"
        :showTemplates="showTemplates"
        @checkTemplates="onCheckTemplates"
        @uncheckedAll="onUncheckedAll" />
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MenuList from '@/components/Menu/List'
import SetMenu from '@/components/Menu/SettingList'
import Pagination from '@/components/Pagination/Pagination'
import Templates from '@/components/Menu/Templates.vue'

export default {
  name: 'Menu',
  components: {
    MenuList,
    SetMenu,
    Pagination,
    Templates
  },
  props: [
    'locale',
    'paging'
  ],
  computed: {
    ...mapGetters({
      menuList: 'menu/list',
      templates: 'menu/templates'
    }),
    setMenu () {
      const mainId = this.$store.state.setting.main.menu
      const main = this.menuList && typeof (mainId) !== 'undefined' ? this.menuList.find(x => x.menuId === mainId) : {}
      const list = this.menuList && typeof (mainId) !== 'undefined' ? this.menuList.filter(x => x.menuId !== mainId) : []
      return {
        main: main,
        list: list
      }
    },
    menuGroup () {
      const sort = this.sortBy
      const list = this.setMenu.list.map(x => x).sort(function (a, b) {
        return a.menuData[sort] > b.menuData[sort] ? -1 : a.menuData[sort] < b.menuData[sort] ? 1 : 0
      })
      const itemCount = this.pagingData.itemCount
      const start = (this.paging - 1) * itemCount
      return list.slice(start, start + itemCount)
    },
    pagingOption () {
      return {
        limit: parseInt(this.setMenu.list.length / this.pagingData.itemCount) + 1,
        force: Number(this.paging)
      }
    }
  },
  created () {
    this.showTemplates = false
    this.$store.commit('onLoading', true)
    this.$store.dispatch('menu/getMenuTemplates')
    this.$store.dispatch('menu/setMenuListData').then(() => {
      this.$store.commit('onLoading', false)
    })
  },
  mounted () {
  },
  data () {
    return {
      showTemplates: false,
      setInit: false,
      checkedList: [],
      sortBy: 'updated',
      pagingData: {
        itemCount: 10 // 페이지당 노출할 리스트 아이템
      }
    }
  },
  methods: {
    onChecked (ids) {
      this.checkedList = ids
      this.setInit = false
    },
    onPagingClick (current) {
      this.$router.replace({ name: 'menuList', params: { paging: current } })
    },
    onUncheckedAll () {
      this.setInit = true
    },
    onCheckTemplates (toggle) {
      this.showTemplates = toggle
    }
  }
}
</script>
